import * as React from "react";

/**
 * Custom hook to handle intervals wrapping setInterval in a React-friendly
 * manner. Original code by Dan Abramov.
 * See {@link https://overreacted.io/making-setinterval-declarative-with-react-hooks/}.
 *
 * @param callback
 * @param delayInMilliseconds
 */
const useInterval = (callback, delayInMilliseconds) => {
  const savedCallback = React.useRef();

  // Remember the latest callback.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  React.useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delayInMilliseconds !== null) {
      let id = setInterval(tick, delayInMilliseconds);
      return () => clearInterval(id);
    }
  }, [delayInMilliseconds]);
};

export default useInterval;
